import React, { useCallback, useEffect, useState } from "react";
import AgentLayout from "../components/AgentLayout";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import UserNavigation from "../users/user-navigation";
import { useDispatch, useSelector } from "react-redux"; 
import { useNavigate, Link } from "react-router-dom";
const AccountCurrentPosition = () => {
  const [pageLoad, setPageLoad] = useState(false);
  const [cricketList, setCricketList] = useState([]);
  const [footballist, setFootballist] = useState([]);
  const [tennisList, setTennisList] = useState([]);
  const [hourseRaceList, setHourseRaceList] = useState([]);

  const [displayUsername, setDisplayUsername] = useState("");

  const userInfo = useSelector((state) => state.userStore);
  const { userId } = useParams();
  useEffect(() => {
    let dataCome = false;
    const fetchEventsById = async () => {
      if (!dataCome) {
        dataCome = true;
        if (userInfo.data !== null) {
          const { data } = await axiosInstance.post(
            "/master/account-current-position",
            { userId }
          ); 

          if (
            data.horse != "" &&
            data.horse !== undefined &&
            data.horse.length > 0
          ) {
            setHourseRaceList(data.horse);
          }

          if (
            data?.cricket != "" &&
            data.cricket != undefined &&
            data.cricket?.length > 0
          ) {
            let cricketArray = [];
            for (let j = 0; j < data.cricket.length; j++) {
              let objFF = data.cricket[j];

              let obj = {};
              let cat_mid = "";
              if (
                objFF.parent_cat_mid != "" &&
                objFF.parent_cat_mid != undefined
              ) {
                cat_mid = objFF.parent_cat_mid;
              } else {
                cat_mid = objFF.CatMid;
              }

              obj.Name = objFF.Name;
              obj.cat_mid = cat_mid;
              obj.child = [];

              const exists = cricketArray.some(
                (user) => user.cat_mid === cat_mid
              );
              if (!exists) {
                cricketArray.push(obj);
              }
            }

            for (let i = 0; i < cricketArray.length; i++) {
              let obj = cricketArray[i];
              for (let j = 0; j < data.cricket.length; j++) {
                let objCrick = data.cricket[j];
                if (objCrick.CatMid == obj.cat_mid) {
                  cricketArray[i].child.push(objCrick);
                }
              }
            }

            cricketArray = cricketArray.sort((a, b) => a.Name - b.Name);

            setCricketList(cricketArray);
          }

          if (
            data?.football != "" &&
            data.football != undefined &&
            data.football?.length > 0
          ) {
            let footballArray = [];
            for (let j = 0; j < data.football.length; j++) {
              let objFF = data.football[j];

              let obj = {};
              let cat_mid = "";
              if (objFF.parent_cat_mid != "") {
                cat_mid = objFF.parent_cat_mid;
              } else {
                cat_mid = objFF.CatMid;
              }

              obj.Name = objFF.eventName;
              obj.cat_mid = cat_mid;
              obj.child = [];

              const exists = footballArray.some(
                (user) => user.cat_mid === cat_mid
              );
              if (!exists) {
                footballArray.push(obj);
              }
            }

            for (let i = 0; i < footballArray.length; i++) {
              let obj = footballArray[i];
              for (let j = 0; j < data.football.length; j++) {
                let objfoot = data.football[j];
                if (objfoot.CatMid == obj.cat_mid) {
                  footballArray[i].child.push(objfoot);
                }
              }
            }
            //console.log("footballArray->", footballArray);
            footballArray = footballArray.sort((a, b) => a.Name - b.Name);
            setFootballist(footballArray);
          }

          if (
            data?.tennis != "" &&
            data.tennis != undefined &&
            data.tennis?.length > 0
          ) {
            setTennisList(data.tennis);
          }

          //console.log("data>", data);
          //let recordList = data.recordList;
          setPageLoad(true);
          dataCome = false;
        }
      }
    };

    fetchEventsById();

    let isMounted = true;
    let timeoutId;

    const fetchByTime = async () => {
      if (!isMounted) return;

      await fetchEventsById();

      timeoutId = setTimeout(fetchByTime, 5000);
    };

    fetchByTime();

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };

    //setInterval(fetchEventsById, 10000);
  }, []);

  useEffect(() => {
    const fetchUserById = async () => {
      if (userId !== "") {
        let tt = userId;
        const response = await axiosInstance.get("user/" + userId);
        console.log(response.data);
        if (
          response !== "" &&
          response.data !== null &&
          response.data !== undefined
        ) {
          setDisplayUsername(response.data?.uname);
        }
      }
    };
    fetchUserById();
  }, []);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <AgentLayout>
      <div
        className="right-content-wrapper"
        style={{ background: "transparent" }}
      >
        <div className="bets-section-wrapper">
          <div className="row">
            <div className="col-12">
              <UserNavigation
                displayUsername={displayUsername}
              ></UserNavigation>
            </div>
            <div
              className="col-12 col-md-12"
              style={{ display: pageLoad ? "" : "none" }}
            >
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <strong className="site_family">Net Exposure</strong>
                    <strong className="btn btn-sm btn-primary site_family">
                      Refresh
                    </strong>
                  </div>
                  <div className="card-body" id="renderall">
                    <table className="table table-sm table-borderless">
                      <thead>
                        <tr style={{ width: "100%" }} className="col-12">
                          <td
                            style={{
                              textAlign: "center",
                              float: "left",
                              width: "30vw"
                            }}
                            className="col-4"
                          ></td>
                          <td
                            style={{ textAlign: "center", width: "10vw" }}
                            className="col-1"
                          >
                            <b className="site_family">1</b>
                          </td>
                          <td
                            style={{ textAlign: "center", width: "10vw" }}
                            className="col-1"
                          >
                            <b className="site_family">X</b>
                          </td>
                          <td
                            style={{ textAlign: "center", width: "10vw" }}
                            className="col-1"
                          >
                            <b className="site_family">2</b>
                          </td>
                          <td
                            style={{ textAlign: "center", width: "20vw" }}
                            className="col-3"
                          ></td>
                          <td
                            style={{ textAlign: "center", width: "10vw" }}
                            className="col-1"
                          >
                            <b className="site_family">Over/Yes</b>
                          </td>
                          <td
                            style={{ textAlign: "center", width: "10vw" }}
                            className="col-1"
                          >
                            <b className="site_family">Under/No</b>
                          </td>
                        </tr>
                      </thead>

                      {!cricketList &&
                        cricketList.map((item, idx) => (
                          <tbody>
                            <tr
                              style={{
                                backgroundColor: "#F0F3F5",
                                width: "100%"
                              }}
                            >
                              <td>
                                <Link
                                  to={`/agent/market-analysis/${item.cat_mid}`}
                                  style={{ fontSize: "15px", color: "black" }}
                                >
                                  <b className="site_family">{item.Name}</b>
                                </Link>
                              </td>
                              <td colspan="6"></td>
                            </tr>
                            {item.child
                              .sort((a, b) => a.mType - b.mType)
                              .map((item1, idx1) => (
                                <tr>
                                  <td className="site_family">
                                    {item1.Name}{" "}
                                    {item1.mType == 1 ? "(MATCH ODD)" : ""}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      backgroundColor: "#E5E8E8"
                                    }}
                                    class={
                                      item1.n0 >= 0
                                        ? "position-plus site_family"
                                        : "position-minus site_family"
                                    }
                                  >
                                    {formatTruncate(item1.n0)}
                                  </td>
                                  <td
                                    style={{ textAlign: "center" }}
                                    class={
                                      item1.n2 >= 0
                                        ? "position-plus site_family"
                                        : "position-minus site_family"
                                    }
                                  >
                                    {" "}
                                    {item1.mType != 6
                                      ? formatTruncate(item1.n2)
                                      : ""}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      backgroundColor: "#E5E8E8"
                                    }}
                                    class={
                                      item1.n1 >= 0
                                        ? "position-plus site_family"
                                        : "position-minus site_family"
                                    }
                                  >
                                    {formatTruncate(item1.n1)}
                                  </td>
                                  <td style={{ textAlign: "center" }}> </td>
                                  <td style={{ textAlign: "center" }}></td>
                                  <td style={{ textAlign: "center" }}></td>
                                  <td style={{ textAlign: "center" }}></td>
                                </tr>
                              ))}
                          </tbody>
                        ))}

                      {!footballist &&
                        footballist.map((item, idx) => (
                          <tbody>
                            <tr
                              style={{
                                backgroundColor: "#F0F3F5",
                                width: "100%"
                              }}
                            >
                              <td>
                                <Link
                                  to={`/agent/market-analysis/${item.cat_mid}`}
                                  style={{ fontSize: "15px", color: "black" }}
                                >
                                  <b className="site_family">{item.Name}</b>
                                </Link>
                              </td>
                              <td colspan="6"></td>
                            </tr>
                            {item.child
                              .sort((a, b) => a.mType - b.mType)
                              .map((item1, idx1) => (
                                <tr>
                                  <td className="site_family">
                                    {item1.Name}{" "}
                                    {item1.mType == 1 ? "(MATCH ODD)" : ""}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      backgroundColor: "#E5E8E8"
                                    }}
                                    class={
                                      item1.n0 >= 0
                                        ? "position-plus site_family"
                                        : "position-minus site_family"
                                    }
                                  >
                                    {formatTruncate(item1.n0)}
                                  </td>
                                  <td
                                    style={{ textAlign: "center" }}
                                    class={
                                      item1.n2 >= 0
                                        ? "position-plus site_family"
                                        : "position-minus site_family"
                                    }
                                  >
                                    {" "}
                                    {item1.mType != 6
                                      ? formatTruncate(item1.n2)
                                      : ""}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      backgroundColor: "#E5E8E8"
                                    }}
                                    class={
                                      item1.n1 >= 0
                                        ? "position-plus site_family"
                                        : "position-minus site_family"
                                    }
                                  >
                                    {formatTruncate(item1.n1)}
                                  </td>
                                  <td style={{ textAlign: "center" }}> </td>
                                  <td style={{ textAlign: "center" }}></td>
                                  <td style={{ textAlign: "center" }}></td>
                                  <td style={{ textAlign: "center" }}></td>
                                </tr>
                              ))}
                          </tbody>
                        ))}

                      {!tennisList &&
                        tennisList.map((item, idx) => (
                          <tbody>
                            <tr
                              style={{
                                backgroundColor: "#F0F3F5",
                                width: "100%"
                              }}
                            >
                              <td>
                                <Link
                                  to={`/agent/market-analysis/${item.cat_mid}`}
                                  style={{ fontSize: "15px", color: "black" }}
                                >
                                  <b className="site_family">{item.Name}</b>
                                </Link>
                              </td>
                              <td colspan="6"></td>
                            </tr>
                            {item.child
                              .sort((a, b) => a.mType - b.mType)
                              .map((item1, idx1) => (
                                <tr>
                                  <td className="site_family">
                                    {item1.Name}{" "}
                                    {item1.mType == 1 ? "(MATCH ODD)" : ""}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      backgroundColor: "#E5E8E8"
                                    }}
                                    class={
                                      item1.n0 >= 0
                                        ? "position-plus site_family"
                                        : "position-minus site_family"
                                    }
                                  >
                                    {formatTruncate(item1.n0)}
                                  </td>
                                  <td
                                    style={{ textAlign: "center" }}
                                    class={
                                      item1.n2 >= 0
                                        ? "position-plus site_family"
                                        : "position-minus site_family"
                                    }
                                  >
                                    {" "}
                                    {item1.mType != 6
                                      ? formatTruncate(item1.n2)
                                      : ""}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      backgroundColor: "#E5E8E8"
                                    }}
                                    class={
                                      item1.n1 >= 0
                                        ? "position-plus site_family"
                                        : "position-minus site_family"
                                    }
                                  >
                                    {formatTruncate(item1.n1)}
                                  </td>
                                  <td style={{ textAlign: "center" }}> </td>
                                  <td style={{ textAlign: "center" }}></td>
                                  <td style={{ textAlign: "center" }}></td>
                                  <td style={{ textAlign: "center" }}></td>
                                </tr>
                              ))}
                          </tbody>
                        ))}
                    </table>
                    <hr />

                    <table class="table table-sm table-striped" border="1">
                      {!hourseRaceList &&
                        hourseRaceList.map((item, idx) => (
                          <tbody>
                            <tr
                              style={{
                                backgroundColor: "dodgerblue",
                                width: "100%"
                              }}
                            >
                              <td colSpan={2}>
                                <Link
                                  style={{ color: "black" }}
                                  target="_blank"
                                  to={`/agent/market-analysis/${item.CatMid}`}
                                >
                                  <b className="site_family">
                                    {item.Name} {item.EvtOd}{" "}
                                    {item.matchSummaryText4}
                                  </b>
                                </Link>
                              </td>
                            </tr>
                            <tr className="table-bordered">
                              <td
                                style={{
                                  textAlign: "left",
                                  paddingLeft: "7vw"
                                }}
                              >
                                <b className="site_family">Runner</b>
                              </td>
                              <td
                                style={{
                                  paddingLeft: "3vw"
                                }}
                              >
                                <b className="site_family">Stake</b>
                              </td>
                            </tr>

                            {item.book.map((item1, idx1) => (
                              <tr>
                                <td
                                  style={{ paddingLeft: "7vw" }}
                                  className="site_family"
                                >
                                  {item1.bet_runner_name} {idx1}
                                </td>
                                <td
                                  className="site_family"
                                  style={{
                                    paddingLeft: "3vw",
                                    color: item1.amount > 0 ? "green" : "red"
                                  }}
                                >
                                  {formatTruncate(item1.amount)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        ))}
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                width: "100%",
                textAlign: "center",
                display: pageLoad ? "none" : "block"
              }}
            >
              <img src="../../assets/images/loadinggif.gif" alt="Loader" />
            </div>
          </div>
        </div>
      </div>
    </AgentLayout>
  );
};

export default AccountCurrentPosition;